import React from 'react';
import { Grid, Button, CardMedia } from '@mui/material';
import '../style/style.css';
import unsplash from '../api/unsplash';
import { login, loginPersistant } from '../utils';
import { useNavigate } from 'react-router-dom';

import soundFile from '../assets/sounds/notification.mp3';
import GlobalSnackbar from './Snackbar';
import Safety from '../assets/images/Safety_sx.png';
import Sfondo from '../assets/images/sfondo.png';
import { Hidden } from '@mui/material';

class Login extends React.Component {
    constructor() {
        super();

        this.state = {
            isChecked: false,
            passwordShown: false,
            openSnack: false,
            snack: {
                severity: 'success',
                messaggio: 'Salvataggio Effettuato correttamente',
                open: false,
            },
            icon: 'bi bi-eye-slash-fill',
        };
    }
    handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ openSnack: false });
    };
    handleCheck = (e) => {
        this.setState({ isChecked: e.target.checked });
    };
    componentDidMount = () => {
        //Coloro lo sfondo solo qui
        //document.body.style.backgroundColor = "rgb(238, 242, 246)";
        document.body.style.backgroundImage = 'url(' + Sfondo + ')';
        document.body.style.backgroundSize = 'cover';
    };
    handleEyeClick = () => {
        this.setState({ passwordShown: !this.state.passwordShown });

        this.state.passwordShown
            ? this.setState({ icon: 'bi bi-eye-slash-fill' })
            : this.setState({ icon: 'bi bi-eye-fill' });
    };

    handleResetPassword = async (event) => {
        this.props.navigate('/reset-password');
    };

    handleAreaLavoratore = async (event) => {
        this.props.navigate('/AreaLavoratore/Login');
    };
    handleAreaMedico = async () => {
        this.props.navigate('/AreaMedico/Login');
    };

    handleLogin = async (event) => {
        event.preventDefault();
        var md5 = require('md5');

        try {
            const response = await unsplash.post('login', {
                username: this.username.value,
                password: md5(this.password.value),
            });
            //this.setState({images:response.data});

            if (response.data.utente.data.length > 0) {
                //Se l'utente ha l'accesso per il Gestionale Koala Interno
                if (response.data.utente.type === 'Interno') {
                    if (this.state.isChecked) {
                        //per login dove si ricorda l'utente
                        loginPersistant(response.data.utente.token);
                    } else {
                        //login chesetta il persistant
                        login(
                            response.data.utente.data[0].foto,
                            response.data.utente.token
                        );
                    }
                    //setto in base ai moduli che dovrà visualizzaere l'utente
                    sessionStorage.setItem(
                        'Medicina',
                        response.data.utente.data[0].Medicina
                    );
                    sessionStorage.setItem(
                        'Sicurezza',
                        response.data.utente.data[0].Sicurezza
                    );
                    sessionStorage.setItem(
                        'Formazione',
                        response.data.utente.data[0].Formazione
                    );
                    sessionStorage.setItem(
                        'VisibilitaLimitata',
                        response.data.utente.data[0].VisibilitaLimitata || 0
                    );

                    //al primo accesso compare il pop-up con Alert Nuovi inserimenti e scadenze varie
                    if (response.data.utente.nAccessi > 0) {
                        sessionStorage.setItem('popup', false);
                    } else {
                        sessionStorage.setItem('popup', true);
                    }

                    //setto paramerti vari
                    await unsplash.post(
                        'storico',
                        {
                            tabella: 'No tabella',
                            key: this.username.value,
                            utente: this.username.value,
                            after: [],
                            before: [],
                            operazione: 'Login',
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${response.data.utente.token}`,
                            },
                        }
                    );

                    sessionStorage.setItem(
                        'username',
                        response.data.utente.data[0].username
                    );
                    sessionStorage.setItem(
                        'idUsername',
                        response.data.utente.data[0].ID
                    );
                    sessionStorage.setItem(
                        'Autorizzazione',
                        response.data.utente.data[0].Admin
                    );
                    sessionStorage.setItem(
                        'tipologia',
                        response.data.utente.data[0].tipoUtente
                    );
                    this.props.navigate('/');
                    if (response.data.utente.tasks > 0) {
                        let sound = new Audio(soundFile);
                        sound.play();
                    }
                }

                //Se l'utente ha l'accesso per il Gestionale Koala Esterno
                if (response.data.utente.type === 'Cliente') {
                    login(null, response.data.utente.token);
                    sessionStorage.setItem(
                        'S',
                        response.data.utente.data[0].Sicurezza
                    );
                    sessionStorage.setItem(
                        'F',
                        response.data.utente.data[0].Formazione
                    );
                    sessionStorage.setItem(
                        'M',
                        response.data.utente.data[0].Medicina
                    );
                    sessionStorage.setItem('VisibilitaLimitata', 0);

                    sessionStorage.setItem(
                        'Cliente',
                        response.data.utente.data[0].Cliente
                    );
                    sessionStorage.setItem(
                        'Notarizzazione',
                        response.data.utente.data[0].Notarizzazione
                    );
                    sessionStorage.setItem('User', this.username.value);
                    this.props.navigate('/AreaClienti/Dashboard');
                }
            } else {
                this.setState({
                    snack: {
                        severity: 'error',
                        messaggio: 'USERNAME O PASSWORD ERRATE',
                    },
                });
                this.setState({ openSnack: true });
            }
        } catch {
            this.setState({
                snack: {
                    severity: 'error',
                    messaggio: 'USERNAME O PASSWORD ERRATE',
                },
            });
            this.setState({ openSnack: true });
        }
    };

    render() {
        return (
            <>
                <GlobalSnackbar
                    severity={this.state.snack.severity}
                    messaggio={this.state.snack.messaggio}
                    openSnack={this.state.openSnack}
                    handleCloseSnack={this.handleCloseSnack}
                />
                <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    display="flex"
                    minHeight="100vh"
                    flexWrap="nowrap"
                >
                    {
                        //#region Immagine Desktop
                    }

                    <Hidden mdDown>
                        <Grid
                            item
                            xs={6}
                            sx={{
                                margin: '30px',
                                borderRadius: '8px',
                            }}
                        >
                            <CardMedia
                                sx={{
                                    borderRadius: '8px',
                                    height: 'calc(100vh - 4rem)',
                                }}
                                component="img"
                                image={Safety}
                                alt="Safety"
                            />
                        </Grid>
                    </Hidden>
                    {
                        //#endregion
                    }
                    {
                        //#region Form per Login
                    }

                    <Grid
                        item
                        xs={8}
                        lg={3}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        style={{ margin: '0 auto' }}
                    >
                        <div className="flex flex-col items-center">
                            <img
                                src={require('../assets/images/Logo-ASTM.png')}
                                className="max-w-full h-auto -mb-[30px]"
                                width="100px"
                                alt="Logo ASTM"
                            />
                            <img
                                src={require('../assets/images/logo.png')}
                                className="max-w-full h-auto"
                                width="500px"
                                alt="Logo Koala"
                            />
                        </div>

                        <form
                            onSubmit={this.handleLogin}
                            style={{ width: '100%' }}
                        >
                            <div className="form-outline mb-4">
                                <label
                                    className="form-label  fs-5"
                                    htmlFor="username"
                                >
                                    Username
                                </label>
                                <input
                                    type="text"
                                    id="username"
                                    name="username"
                                    placeholder="Inserisci l'username"
                                    ref={(username) =>
                                        (this.username = username)
                                    }
                                    className="block appearance-none w-full  mb-1 text-gray-800 border border-gray-200 py-2 px-4 text-lg leading-normal rounded bg-white fs-6"
                                />
                            </div>

                            <label
                                className="form-label fs-5"
                                htmlFor="password"
                            >
                                Password
                            </label>
                            <div className="form-outline mb-4 relative flex items-stretch w-full">
                                <input
                                    type={
                                        this.state.passwordShown
                                            ? 'text'
                                            : 'password'
                                    }
                                    id="password"
                                    name="password"
                                    placeholder="Inserisci la password"
                                    ref={(password) =>
                                        (this.password = password)
                                    }
                                    className="block appearance-none w-full  mb-1   text-gray-800 border border-gray-200 py-2 px-4 text-lg leading-normal rounded border-r-0 bg-white fs-6"
                                />
                                <span className="input-group-text bg-transparent">
                                    <i
                                        className={this.state.icon}
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.handleEyeClick}
                                    ></i>
                                </span>
                            </div>

                            <div className="flex justify-around items-center mb-4"></div>

                            <Button
                                type="submit"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={this.handleLogin}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#11526f',
                                    marginBottom: '10px',
                                }}
                            >
                                Login{' '}
                            </Button>
                            <br></br>
                            <Button
                                type="button"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={this.handleResetPassword}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#11526f',
                                }}
                            >
                                Reset Password{' '}
                            </Button>
                            <br></br>
                            <Button
                                type="button"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={this.handleAreaLavoratore}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#11526f',
                                    marginTop: '20px',
                                }}
                            >
                                Area Lavoratore
                            </Button>
                            <Button
                                type="button"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={this.handleAreaMedico}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#11526f',
                                    marginTop: '20px',
                                }}
                            >
                                Area Medico
                            </Button>
                        </form>
                    </Grid>
                    {
                        //#endregion
                    }
                </Grid>
            </>
        );
    }
}

function WithNavigate(props) {
    const navigate = useNavigate();

    return <Login {...props} navigate={navigate} />;
}

export default WithNavigate;
